// PE-6108 — shared HTML helpers for appointment confirmation emails
export function escapeHtml(value: string | null | undefined): string {
  if (value == null) {
    return '';
  }
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

export function applyMergeFields(template: string, fields: Record<string, string>): string {
  return Object.entries(fields).reduce(
    (result, [key, value]) =>
      result.replace(new RegExp(`\\{\\{${key}\\}\\}`, 'g'), value),
    template
  );
}

export function buildOptionalParagraphBlock(text: string | undefined): string {
  const trimmed = text?.trim();
  if (!trimmed) {
    return '';
  }
  return `<p style="margin:0 0 16px 0;font-size:16px;line-height:24px;color:#111827;font-family:Arial,Helvetica,sans-serif;">${escapeHtml(trimmed)}</p>`;
}

export function buildTenantDepartmentBlock(tenantName: string, departmentName: string): string {
  const tenant = tenantName?.trim();
  const department = departmentName?.trim();
  if (!tenant && !department) {
    return '';
  }
  const label = tenant && department ? `${tenant} - ${department}` : tenant || department;
  return `<p style="margin:16px 0 0 0;font-size:14px;line-height:20px;color:#4b5961;text-align:center;font-family:Arial,Helvetica,sans-serif;">${escapeHtml(label)}</p>`;
}
